import React, { useEffect, useState } from 'react';
import { TbTicTac } from 'react-icons/tb';
import Cell from './Cell';

const possibles = [ [0, 1, 2],[3, 4, 5],[6, 7, 8],[0, 3, 6],[1, 4, 7],[2, 5, 8],[0, 4, 8],[2, 4, 6] ];

const checkWinner = (cells) => {
  for (let i = 0; i < possibles.length; i++) {
    let checkStr = possibles[i].map((index) => cells[index]).join('');
    if (checkStr.includes('XXX')) {
      return 'X';
    } else if (checkStr.includes('OOO')) {
      return 'O';
    }
  }
  if (!cells.includes(null)) {
    return 'DRAW';
  }
  return null;
};

export default function Board({ isAutoPlay, resetHistory, updateMoves, currentMove, isEasy }) {
  const [isDisabled, setDisabled] = useState(false);
  const [isGameEnd, setIsGameEnd] = useState(false);
  const [isX, setIsX] = useState(true);
  const [cells, setCells] = useState(currentMove);
  const [status, setStatus] = useState( isX ? 'Next player : X' : 'Next player : O');

  const setResult = (newCells) => {
    const result = checkWinner(newCells);
    if (result) {
      // if result is not null game will be end.
      setIsGameEnd(true);
      setStatus(
        result !== 'DRAW'
          ? 'Winner Is : ' + result
          : 'Match ' + result + '!'
      );
    } else {
      setStatus('Next player : ' + (!isX ? 'X' : 'O'));
    }
  };

  const handleClick = (index) => {
    const newCells = cells.slice();
    const player = isX ? 'X' : 'O';
    if (!newCells[index]) {
      newCells[index] = player;
      setCells(newCells);
      setIsX(!isX);
      setResult(newCells);
      updateMoves(newCells);
    }
  };

  const autoPlay = (cells) => {
  var hardInd = null;
    const newCells = cells
      .map((element, index) => (element === null ? index : undefined))
      .filter((index) => index !== undefined);
    const ind = Math.floor(Math.random() * newCells.length);
    if (isEasy) {
      return newCells[ind];
    } else {
      for (let i = 0; i < possibles.length; i++) {
        let checkStr = possibles[i].map((index) => cells[index]).join('');
        if (checkStr.includes('OO')) {
          newCells.map((v) => {
            if(possibles[i].includes(v)) {
              hardInd = v;
              return;
            }
          });
        }
        if(checkStr.includes('XX')){
          newCells.map((v) => {
          if(possibles[i].includes(v)) {
            hardInd = v;
            return;
          }
        });
        }
      }
      return hardInd === null ? newCells[ind] : hardInd ;
    }
  };

  useEffect(() => {
    reset();
  }, [isAutoPlay, isEasy]);

  useEffect(() => {
    setCells(currentMove);
    var xCount = 0; var oCount = 0;
    for (let i = 0 ; i < currentMove.length ; i++){
      if(currentMove[i] === 'X' ) {
        xCount ++;
      } else if (currentMove[i] === 'O'){
        oCount++;
      }
    }
    let currentPlayer = xCount > oCount ? false : true;
    setIsX(currentPlayer);
  }, [currentMove])

  useEffect(() => {
    if (isAutoPlay && !isX && cells.includes(null) && !isGameEnd) {
      setDisabled(true);
      setTimeout(() => {
        const newCells = cells.slice();
        var inde = autoPlay(cells);
        newCells[inde] = isX ? 'X' : 'O';
        setCells(newCells);
        setIsX(!isX);
        setResult(newCells);
        updateMoves(newCells);
        setDisabled(false);
      }, 500);
    }
  }, [isX]);

  const reset = () => {
    setStatus(isX ? 'Next player : X' : 'Next player : O');
    setIsGameEnd(false);
    const newCells = Array(9).fill(null);
    setCells(newCells);
    setCells(currentMove);
    resetHistory()
    if (isAutoPlay && !isX) {
      setTimeout(() => {
        var inde = autoPlay(newCells);
        newCells[inde] = 'O';
        setCells(newCells);
        setIsX(!isX);
        setResult(newCells);
        resetHistory()
      }, 300);
    }
  };

  return (
    <section className='tic-container'>
      <div
        className='board'
        style={{ pointerEvents: isDisabled || isGameEnd ? 'none' : '' }}
      >
        <h1 className='playerInfo'>
          <TbTicTac style={{ fontSize: '3rem' }} /> &nbsp; {status}
        </h1>
        <div className='board-row'>
          <Cell value={cells[0]} handleClick={() => handleClick(0)} />
          <Cell value={cells[1]} handleClick={() => handleClick(1)} />
          <Cell value={cells[2]} handleClick={() => handleClick(2)} />
        </div>
        <div className='board-row'>
          <Cell value={cells[3]} handleClick={() => handleClick(3)} />
          <Cell value={cells[4]} handleClick={() => handleClick(4)} />
          <Cell value={cells[5]} handleClick={() => handleClick(5)} />
        </div>
        <div className='board-row'>
          <Cell value={cells[6]} handleClick={() => handleClick(6)} />
          <Cell value={cells[7]} handleClick={() => handleClick(7)} />
          <Cell value={cells[8]} handleClick={() => handleClick(8)} />
        </div>
      </div>
      {isGameEnd && (
        <button className='reset-btn' onClick={reset}>
          Reset Game
        </button>
      )}
    </section>
  );
}
